import http from './httpService';

let apiEndpoint = '/crossfades';

export function getCrossfadeImagesByName(name) {
  return http.get(`${apiEndpoint}/${name}`);
}

export function updateCrossfadeImages(formData, name) {
  return http.put(`${apiEndpoint}/${name}`, formData);
}
